export default __webpack_public_path__ + "static/media/arvestdash.93df754d.png";